import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'

import { ProjectStatus } from '@/pages/projects'

interface ProjectsState {
  statusFilters: ProjectStatus[]
  statusFilterForTrash: ProjectStatus[]
  selectedRows: string[]
  setTrashSelectedRows: string[]
  selectedTrashIds: string[]
  selectedCaseIds: string[]
  selectedCaseName: string[]
  selectedImageIds: Record<string, number[]>
  imageId: string | string[] | null
  selectedRecipeIds: number[]
}

const initialState: ProjectsState = {
  statusFilters: [],
  statusFilterForTrash: [],
  selectedRows: [],
  selectedCaseIds: [],
  selectedTrashIds: [],
  setTrashSelectedRows: [],
  selectedCaseName: [],
  selectedImageIds: {},
  imageId: null,
  selectedRecipeIds: [],
}

export const projectsSlice = createSlice({
  name: 'projects',
  initialState,
  reducers: {
    setStatusFilters: (state, action: PayloadAction<ProjectStatus[]>) => {
      state.statusFilters = action.payload
    },
    setStatusFiltersForTrash: (
      state,
      action: PayloadAction<ProjectStatus[]>,
    ) => {
      state.statusFilterForTrash = action.payload
    },
    toggleSelectedRow: (
      state,
      action: PayloadAction<{ id: string; name: string }>,
    ) => {
      const { id, name } = action.payload

      state.selectedRows = state.selectedRows.includes(id)
        ? state.selectedRows.filter((i) => i !== id)
        : [...state.selectedRows, id]

      state.selectedCaseIds = state.selectedCaseIds.includes(id)
        ? state.selectedCaseIds.filter((i) => i !== id)
        : [...state.selectedCaseIds, id]

      state.selectedCaseName = state.selectedCaseName.includes(name)
        ? state.selectedCaseName.filter((i) => i !== name)
        : [...state.selectedCaseName, name]
    },

    // toggleTrashSelectedRow: (
    //   state,
    //   action: PayloadAction<{ index: number; id: string }>,
    // ) => {
    //   const { index, id } = action.payload

    //   state.setTrashSelectedRows = state.setTrashSelectedRows.includes(index)
    //     ? state.setTrashSelectedRows.filter((i) => i !== index)
    //     : [...state.setTrashSelectedRows, index]

    //   state.selectedTrashIds = state.selectedTrashIds.includes(id)
    //     ? state.selectedTrashIds.filter((i) => i !== id)
    //     : [...state.selectedTrashIds, id]
    // },
    toggleTrashSelectedRow: (state, action: PayloadAction<{ id: string }>) => {
      const { id } = action.payload

      state.setTrashSelectedRows = state.setTrashSelectedRows.includes(id)
        ? state.setTrashSelectedRows.filter((i) => i !== id)
        : [...state.setTrashSelectedRows, id]

      state.selectedTrashIds = state.selectedTrashIds.includes(id)
        ? state.selectedTrashIds.filter((i) => i !== id)
        : [...state.selectedTrashIds, id]
    },
    clearSelectedCases: (state) => {
      state.selectedRows = []
      state.selectedCaseIds = []
      state.selectedCaseName = []
    },
    clearTrashSelectedCases: (state) => {
      state.setTrashSelectedRows = []
      state.selectedTrashIds = []
    },
    toggleImageSelection: (
      state,
      action: PayloadAction<{ imageId: string; caseId: string }>,
    ) => {
      const { imageId, caseId } = action.payload
      const selected = state.selectedImageIds[caseId] || []

      if (selected.includes(imageId)) {
        state.selectedImageIds[caseId] = selected.filter((id) => id !== imageId)
      } else {
        state.selectedImageIds[caseId] = [...selected, imageId]
      }
    },
    clearImageSelection: (state, action: PayloadAction<string>) => {
      delete state.selectedImageIds[action.payload]
    },
    setImageId(state, action: PayloadAction<string | string[]>) {
      state.imageId = action.payload
    },
    toggleRecipeSelection: (state, action) => {
      const id = action.payload
      if (state.selectedRecipeIds.includes(id)) {
        state.selectedRecipeIds = state.selectedRecipeIds.filter(
          (i) => i !== id,
        )
      } else {
        state.selectedRecipeIds.push(id)
      }
    },
    setSelectedRecipeIds: (state, action) => {
      state.selectedRecipeIds = action.payload
    },
    clearSelectedRecipeIds: (state) => {
      state.selectedRecipeIds = []
    },
    resetProjectState: () => initialState,
    removeSelectedRow: (state, action: PayloadAction<string>) => {
      const idToRemove = action.payload

      state.selectedRows = state.selectedRows.filter((id) => id !== idToRemove)
      state.selectedCaseIds = state.selectedCaseIds.filter(
        (id) => id !== idToRemove,
      )
      state.selectedCaseName = state.selectedCaseName.filter(
        (_, idx) => state.selectedCaseIds[idx] !== idToRemove,
      )
    },
    removeTrashSelectedRow: (state, action: PayloadAction<string>) => {
      const idToRemove = action.payload

      state.setTrashSelectedRows = state.setTrashSelectedRows.filter(
        (id) => id !== idToRemove,
      )
      state.selectedTrashIds = state.selectedTrashIds.filter(
        (id) => id !== idToRemove,
      )
    },
  },
})

export const {
  setStatusFilters,
  setStatusFiltersForTrash,
  toggleSelectedRow,
  toggleTrashSelectedRow,
  clearSelectedCases,
  clearTrashSelectedCases,
  toggleImageSelection,
  clearImageSelection,
  setImageId,
  toggleRecipeSelection,
  setSelectedRecipeIds,
  clearSelectedRecipeIds,
  resetProjectState,
  removeSelectedRow,
  removeTrashSelectedRow,
} = projectsSlice.actions
export default projectsSlice.reducer
